export default __webpack_public_path__ + "static/media/Concept_Clarity_Through_Visual.8353be74.png";